import { defineComponent } from 'vue';
import EnergyTable from '@hems/user/src/components/table/EnergyTable.vue';
export default defineComponent({
    name: 'EnergyBalance',
    components: {
        EnergyTable,
    },
    props: {
        data: {
            type: Array,
            required: true,
        },
    },
});
